import * as React from "react";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";

export const DatePickerField = ({
	value,
	onChange,
	field,
	...props
}) => {
	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<DatePicker
				value={value ? dayjs(value) : null}
				className="registration-formField"
				openTo="month"
				views={["year", "month", "day"]}
				clearable
				onChange={(newValue) => {
					if (!newValue) {
						// User clicked the clear (X) button
						onChange(null);
						return;
					}

					// Convert to local date safely
					const formattedDate = moment(new Date(newValue)).format("YYYY-MM-DD");
					console.log("Selected date:", formattedDate, newValue);
					onChange(formattedDate);
				}}
				{...props}
			/>
		</LocalizationProvider>
	);
};

export default DatePickerField;
